import api from './api'

export async function getState() {
  const res = await api.get('/api/v1/onboarding/state')
  return res.data
}

export async function updateState(patch) {
  const res = await api.put('/api/v1/onboarding/state', patch)
  return res.data
}

export async function enableWarmup(emailAccountId) {
  const res = await api.post('/api/v1/warmup/enable', { email_account_id: emailAccountId })
  return res.data
}
